// extracted by mini-css-extract-plugin
module.exports = {"MenuBtn":"MenuBtn_MenuBtn__3uCm9"};